import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  breakStringIntoLines,
  crypt,
  formatDate,
  getNewParameters,
  getObjectSubset,
  getParameters,
  paymentModeModification,
} from "../../lib/helper";
import { LegalListingItemsSelector } from "../../redux/legal";
import {
  ConfirmedOrderListings,
} from "../../Services/legal";
import MatTable from "../Tables/MatTable";
import AllFilters from "../Order/AllFilters";
import { SearchByOrder } from "../../data/LegalData";

const column = [
  {
    label: "Order ID",
    id: "order_id",
    format: (columnData) => (
        <Typography variant="span" style={{ whiteSpace: "nowrap" }}>
          {columnData}
        </Typography>
    ),
    nextLine: true,
  },
  {
    label: "Email",
    id: "email",
    format: (columnData) => (
      <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>
        {columnData || "N/A"}
      </span>
    ),
  },
  {
    label: "Client",
    id: "client",
    format: (columnData) => (
      <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>
        {columnData ? breakStringIntoLines(columnData, 20) : 'N/A'}
      </span>
    ),
  },
  {
    label: "Company Name",
    id: "company",
    format: (columnData) => (
      <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>
        {columnData ? breakStringIntoLines(columnData, 20) : 'N/A'}
      </span>
    ),
  },
  {
    label: "Order Date",
    id: "ordered_on",
    format: (columnData) => (
      <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>
        {formatDate(columnData, "dd/mm/yyyy")}
      </span>
    ),
  },
  {
    label: "Payment Mode",
    id: "payment_type",
    format: (columnData) => (
      <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>
        {columnData ? paymentModeModification(columnData) : "N/A"}
      </span>
    ),
    nextLine: true,
  },
  {
    label: "Invoice ID",
    id: "invoice_id",
    format: (columnData, rowIndex, formatCallback, arr, errors, row) => {
      if (row?.order_status > 0) {
        return columnData ? (
          <Link
            className="textDecoration-none link-text"
            to={`../../invoice?orderId=${crypt("order_id", row?.order_id)}`}
            target={"_blank"}
          >
            {columnData}
          </Link>
        ) : (
          <Typography variant="span" style={{ whiteSpace: "nowrap" }}>
            {columnData}
          </Typography>
        );
      }
      return null;
    },
    nextLine: true,
  },
  {
    label: "Payment Status",
    id: "payment_status",
    format: (columnData, rowIndex, formatCallback, arr, errors, row) => (
      <>
        <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>
          {columnData == "0" ? "Unpaid" : "Paid"}
        </span>
        {row?.paid_on ? (
          <Typography variant="p" display={"block"} className="colorHiglight2">
            {formatDate(row.paid_on, "dd/mm/yyyy")}
          </Typography>
        ) : null}
        {row?.previous_order_id ? (
          <Typography variant="p" display={"block"} className="colorHiglight">
            RefID:{row?.previous_order_id}
          </Typography>
        ) : null}
      </>
    ),
    nextLine: true,
  },
  {
    label: "Order Status",
    id: "order_status",
    format: (columnData, rowIndex, formatCallback, arr, errors, row) => (
      <>
        <Typography
          variant="span"
          sx={{ color: "success.main", display: "inline-block" }}
        >
          C
        </Typography>
        <Typography variant="span" component={"div"}>
          {row?.order_type}
        </Typography>
      </>
    ),
    nextLine: true,
  },
  {
    label: "Clearence Date",
    id: "payment_on",
    format: (columnData) => (
      <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>
        {formatDate(columnData, "dd/mm/yyyy")}
      </span>
    ),
    nextLine: true,
  },
];

function ConfirmedOrder() {
  const [orderListing, setOrderListing] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [allParams, setAllParams] = useState(getParameters());
  const { loading, confirmedOrders } = useSelector(LegalListingItemsSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [filtersArray, setFiltersArray] = useState([
    {
      label: "Search By",
      id: "search_by",
      type: "select",
      linkedWith: null,
      value: "",
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: SearchByOrder,
      props: {},
      isVisible: true,
    },
    {
      label: "Search Text",
      id: "search",
      type: "input",
      linkedWith: null,
      value: "",
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e?.target?.value;
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: {},
      isVisible: true,
    },
  ]);
  const getOrderListing = async (params = {}) => {
    const payload = {
      page: String(1),
      limit: limit,
      order_status: String(1),
      ...allParams,
      ...params,
    };
    dispatch(ConfirmedOrderListings(payload));
    setPage(Number(payload.page));
  };
  const handleFilter = (data, allDatavalues, dataWithValue) => {
    getOrderListing(
      {
        page: String(1),
        ...dataWithValue,
      },
      true
    );
    setAllParams({
      page: String(1),
      ...dataWithValue,
    });
  };
  const handleClear = () => {
    const data = getObjectSubset({ ...allParams }, "tab", "page");
    setAllParams(data);
    setFiltersArray((prevState) => {
      let newState = [...prevState];
      newState[0].isVisible = true;
      newState[1].isVisible = true;

      newState[0].value = "";
      newState[1].value = "";
      return newState;
    });
  };

  useEffect(() => {
    if (confirmedOrders?.items?.orders?.length >= 0) {
      let data = confirmedOrders?.items?.orders?.map((item) => {
        return {
          order_id: item.order_id,
          user_id: item.user_id,
          email: item.user.email,
          client: item.client,
          company: item.company,
          payment_type: item.payment_type,
          ordered_on: item.ordered_on,
          accepted_or_rejected_on: item.accepted_or_rejected_on,
          previous_order_id: item.previous_order_id,
          payment_on: item.payment_on,
          order_type: item.order_type,
          order_status: item.order_status,
          paid_on: item.paid_on,
          payment_status: item.payment_status,
          invoice_id: item?.invoice?.invoice_id || null,
          gst_number: item?.invoice?.gst_number || null,
          comment: item?.comment,
          special_comment: item?.grouping_manage?.special_comment || null,
          irn_status: item?.irn_status,
          purchase_order_detail: item?.purchase_order_detail,
          purchase_order: item?.purchase_order,
          voucher_id: item?.voucher_id,
          voucher_expiry: item?.voucher_expiry,
          voucher_price: item?.voucher_price,
          voucher_email: item?.voucher_email,
        };
      });
      setOrderListing(data);
    }
  }, [confirmedOrders.items]);

  useEffect(() => {
    getOrderListing();
  }, []);

  useEffect(() => {
    let params = getParameters();
    setAllParams(params);
  }, [location?.search]);

  useEffect(() => {
    let data = getNewParameters(allParams);
    if (data?.search !== location.search) {
      navigate(data.newUrl, { replace: false });
      if (data?.parameters?.page) {
        setPage(Number(data?.parameters?.page));
      }
    }
    getOrderListing();
  }, [allParams]);

  return (
    <>
      <MatTable
        loading={confirmedOrders?.loading}
        showCheckbox={false}
        columns={column}
        data={orderListing}
        page={page}
        showPageLimit={true}
        handleChangePageLimit={(e) => {
          setLimit(e.target.value);
          setAllParams({
            ...allParams,
            page: String("1"),
            limit: Number(e.target.value),
          });
        }}
        perPage={limit}
        total={confirmedOrders?.items?.totalCount || 0}
        setPage={setPage}
        handleSearch={(searchTerm) => {
          getOrderListing({
            page: String(1),
            search: searchTerm,
          });
          setAllParams({
            ...allParams,
            page: String(1),
            search: searchTerm,
          });
        }}
        handlePageChange={(newPage) => {
          getOrderListing({
            page: String(newPage),
          });
          setAllParams({
            ...allParams,
            page: String(newPage),
          });
        }}
        toolbarEnable={true}
        pagination={true}
        filtersUrlData={allParams || {}}
        rangeDateFilter
        disableSearch
        customFilter={() => (
          <AllFilters
            filtersArray={filtersArray}
            handleClick={handleFilter}
            handleClear={handleClear}
          />
        )}
      />
    </>
  );
}

export default ConfirmedOrder;